const ObjectionPreemption = () => (
  <section className="py-16 bg-[#0b0f13] text-white" data-testid="objection-preemption">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="border-l-4 border-[#137dc5] pl-8">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          "I Already Know the Water. Why Would I Need This?"
        </h2>
        <div className="space-y-6 text-lg text-slate-300">
          <p>
            <strong className="text-white">Fair question.</strong> If you've been fishing the Madison for 15 years, you don't need an app to tell you that PMDs hatch in July or that the San Juan has midges year-round.
          </p>
          <p>
            <strong className="text-white">But here's what even experienced anglers can't do:</strong>
          </p>
          <ul className="list-disc list-inside space-y-3 ml-4 text-slate-300">
            <li>
              <strong className="text-[#3aa0e0]">Track 50+ watersheds simultaneously.</strong> You know your home water. But when you travel to the Bow River in April or the Frying Pan in September, you're guessing on timing windows. FlyFinder's <strong className="text-white">Regional Hatch Calendar</strong> shows exactly what's active there, month by month, from larvae to adult.
            </li>
            <li>
              <strong className="text-[#3aa0e0]">Cross-reference water temp + weather + photoperiod in real time.</strong> You might check the forecast. FlyFinder's <strong className="text-white">AI Recommendations</strong> check temperature triggers for active species and weight them against current barometric pressure and cloud cover &mdash; then tell you the exact fly, size, and technique for right now.
            </li>
            <li>
              <strong className="text-[#3aa0e0]">Remember every micro-hatch and secondary emergence.</strong> BWO? Sure. But which species of Baetis? What size? Is it the early-season bicaudatus or the fall tricaudatus? Different flies, different presentation.
            </li>
          </ul>
          <p>
            <strong className="text-white">FlyFinder isn't replacing your knowledge.</strong> It's extending it. Think of it as having a fishing partner who's documented every hatch on every major river in North America and can recall it instantly while you're rigging up.
          </p>
          <p className="text-slate-400 italic border-t border-slate-700 pt-6 mt-6">
            "We built this because we were tired of arriving at a famous river we've never fished and wasting the first half-day figuring out what's working. Now we check FlyFinder, adjust for conditions, and start catching fish immediately." — FlyFinder Team
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default ObjectionPreemption;
